import { CountryVM, NationalityVM } from "../models";
import { FormGroup, AbstractControl, ValidatorFn } from "@angular/forms";
import * as moment from 'moment';
import { Moment } from "moment";

export class Utils {

  public static calculateAge(dateOfBirth: Moment): number {
    let today = moment();
    var age = 0;

    if (dateOfBirth.isValid()) {
      age = today.diff(dateOfBirth, 'years');
    }

    return age;
  }

  public static checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      let passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
        return passwordConfirmationInput.setErrors(null);
      }
    }
  }
}

export function minAgeValidator(minAge: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let dob = moment(control.value, 'DD/MM/YYYY');
    return Utils.calculateAge(dob) < minAge ? { 'minAgeNotMet': { value: control.value } } : null;
  };
}
